import React from 'react'
import { FormattedMessage } from 'react-intl'

import { CostMessagingModalContent, CoverageType, GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic'

import { Link } from '../atoms'
import { therapyOrCoachingTitle } from './util/DefaultCoverageTexts'

export const getThatchCostMessagingModalText = (
  numberOfSessions: string,
  isCustomerDynamicSessionLimitEnabled: boolean, // isCustomerDynamicSessionLimitEnabled is true for Thatch if the user is logged out
): CostMessagingModalContent[] => [
  {
    title: therapyOrCoachingTitle,
    description: isCustomerDynamicSessionLimitEnabled ? (
      <FormattedMessage
        defaultMessage='Meet 1-on-1 with a mental health provider when you need support.'
        description='Logged out cost messaging modal session description for Thatch'
      />
    ) : (
      <FormattedMessage
        defaultMessage='Meet with a provider up to {numberOfSessions} times—purchased from Thatch.'
        description='Logged in cost messaging modal session description for Thatch'
        values={{ numberOfSessions }}
      />
    ),
    contentType: 'ThatchTherapy',
  },
]

const getCostMessagingModalText = (
  numberOfSessions: string,
  isCustomerDynamicSessionLimitEnabled: boolean,
): { [key in CoverageType]: () => CostMessagingModalContent[] } => {
  const costMessagingModalText = getThatchCostMessagingModalText(numberOfSessions, isCustomerDynamicSessionLimitEnabled)
  return {
    [CoverageType.EAP_ONLY]: () => {
      // only EAP_ONLY is supported for Thatch
      return costMessagingModalText
    },
    [CoverageType.HPI_ONLY]: () => {
      return costMessagingModalText
    },
    [CoverageType.EAP_AND_HPI]: () => {
      return costMessagingModalText
    },
  }
}

export const thatch: GetCustomerCopyFunc = ({ numberOfSessions, isCustomerDynamicSessionLimitEnabled }) => {
  return {
    costMessagingModalText: getCostMessagingModalText(
      numberOfSessions || '',
      isCustomerDynamicSessionLimitEnabled == null ? true : isCustomerDynamicSessionLimitEnabled, // isCustomerDynamicSessionLimitEnabled is true for Thatch if the user is logged out
    ),
    coverageModalTitleText: (
      <FormattedMessage
        defaultMessage='Your Lyra sessions through Thatch'
        description='Header text for coverage modal'
      />
    ),
    sessionHistoryDescriptionText: ({ goToCareNavigatorPage, benefitEndDate }) => (
      <FormattedMessage
        defaultMessage='Session history reflects your activity for the current access period. Your sessions are available to access through {benefitEndDate}. Questions? Reach out to a <link>Care Navigator</link>.'
        description='Text to inform Thatch members about their session end date.'
        values={{
          benefitEndDate,
          link: (text: string) => <Link onPress={() => goToCareNavigatorPage()} text={text} underline={true} />,
        }}
      />
    ),
    noCostCareOptionsTitle: (
      <FormattedMessage defaultMessage='Care options' description='Title for care options section' />
    ),
    eligibilitySubtitleText: (benefitEndDate: string) => (
      <FormattedMessage
        defaultMessage='Your sessions were purchased through Thatch and are available to access through {benefitEndDate}. After this access period, your Lyra account will become inactive.'
        description='Subtitle text for Thatch eligibility section'
        values={{ benefitEndDate }}
      />
    ),
  }
}
